import React from 'react';
import { Link } from 'react-router-dom';
import DawidFoto3 from '../../images/DawidFoto3.png';

import css from './MainSecond.module.css';

const MainSecond = () => {
	return (
		<section className={css.aboutSection}>
			<div className={css.aboutTitleWrapper}>
				<h2 className={css.aboutTitle}>KILKA SŁÓW O MNIE</h2>
			</div>
			<div className={css.aboutBackground}>
				<h3 className={css.aboutSubTitle}>DAWID LEWKO</h3>
				<div className={css.aboutContainer}>
					<div className={css.aboutContainerSmall}>
						<img className={css.aboutImgFoto} src={DawidFoto3} alt="about" />
						<Link to="/o-nas">
							<button className={css.aboutButton}>Więcej o mnie</button>
						</Link>
					</div>
					<div>
						<p className={css.aboutText}>
							Jestem magistrem psychologii, ukończyłem studia w 2024 roku. Moje
							doświadczenie obejmuje pracę jako praktykant w Areszcie Śledczym,
							gdzie zdobyłem cenne umiejętności i wiedzę w pracy z różnymi
							grupami osób.
							<br />
							<br />
							Cechuje mnie duże zaangażowanie w podejmowane działania oraz
							nieustanna chęć rozwoju i nauki. Moje kluczowe umiejętności
							obejmują:
						</p>
						<ul className={css.aboutList}>
							<li>
								<span className={css.aboutTextWhite}>
									Komunikację i aktywne słuchanie
								</span>{' '}
								– potrafię budować relacje oparte na zaufaniu, co jest kluczowe
								w pracy terapeutycznej.
							</li>
							<li>
								<span className={css.aboutTextWhite}>Psychoedukację</span> – z
								zaangażowaniem dzielę się wiedzą i pomagam zrozumieć mechanizmy
								psychologiczne.
							</li>
							<li>
								<span className={css.aboutTextWhite}>
									Opanowanie w sytuacjach stresowych
								</span>{' '}
								– potrafię zachować spokój i obiektywizm, nawet w trudnych
								momentach.
							</li>

							<li>
								<span className={css.aboutTextWhite}>Wsparcie emocjonalne</span>{' '}
								– udzielam pomocy w sposób empatyczny, tworząc bezpieczną
								przestrzeń dla klienta.
							</li>
							<li>
								<span className={css.aboutTextWhite}>
									Zdolności organizacyjne{' '}
								</span>
								– efektywnie planuję swoją pracę, by spełnić potrzeby każdego
								klienta.
							</li>
						</ul>
						<p className={css.aboutText}>
							Posiadam także doświadczenie w pracy zarówno z dziećmi, jak i
							dorosłymi. Szybko przyswajam nowe umiejętności i swobodnie
							posługuję się językiem angielskim na poziomie B2.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default MainSecond;
